const NoRowsOverlay = () => {
  return (
    <div className='flex h-full items-center justify-center'>
      Create a new Forecast, click on <span className='font-bold pl-1'>+Create new</span>
    </div>
  );
};

export default NoRowsOverlay;
